var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrowDownIntoTray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_667_519)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.25C8.41421 1.25 8.75 1.58579 8.75 2V11.3333C8.75 11.7475 8.41421 12.0833 8 12.0833C7.58579 12.0833 7.25 11.7475 7.25 11.3333V2C7.25 1.58579 7.58579 1.25 8 1.25Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 10.5833C2.41421 10.5833 2.75 10.9191 2.75 11.3333C2.75 12.3918 3.60821 13.25 4.66667 13.25H11.3333C12.3918 13.25 13.25 12.3918 13.25 11.3333C13.25 10.9191 13.5858 10.5833 14 10.5833C14.4142 10.5833 14.75 10.9191 14.75 11.3333C14.75 13.2202 13.2202 14.75 11.3333 14.75H4.66667C2.77979 14.75 1.25 13.2202 1.25 11.3333C1.25 10.9191 1.58579 10.5833 2 10.5833Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.13574 7.46962C4.42866 7.17675 4.90353 7.1768 5.1964 7.46972L7.9994 10.2733L10.803 7.46967C11.0959 7.17678 11.5708 7.17678 11.8637 7.46967C12.1566 7.76256 12.1566 8.23744 11.8637 8.53033L8.52968 11.8643C8.38902 12.005 8.19824 12.084 7.99931 12.084C7.80039 12.084 7.60961 12.005 7.46897 11.8643L4.13563 8.53028C3.84277 8.23735 3.84282 7.76248 4.13574 7.46962Z",
    className: "icon-fill"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_667_519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDownIntoTray);
export default __webpack_public_path__ + "static/media/icon-arrow-down-into-tray.529f49d36c8cf8ceeff350b3285ae85d.svg";
export { ForwardRef as ReactComponent };